import { NavBar, NavBarItem, Text } from '@audio-network/componentlibrary'

import DesktopNavBarProps from './DesktopNavBar.types'
import Link from 'next/link'
import React from 'react'
import { Search } from '@audio-network/componentlibrary/icons'
import { sendAnalytics } from '@audio-network/analytics'
import styles from './DesktopNavBar.module.css'
import { useTranslation } from 'next-i18next'

const DesktopNavBar = ({
	showSoundEffects,
}: DesktopNavBarProps): JSX.Element => {
	const { t } = useTranslation(['navigation'])

	const handleClick = (noun: string): void => {
		sendAnalytics({
			noun,
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}
	return (
		<NavBar className={styles.desktopNavBar} id="desktop-nav-bar">
			<Link href="/track/searchkeyword" legacyBehavior passHref locale={false}>
				<NavBarItem
					content={showSoundEffects ? t('music') : t('search')}
					startIcon={<Search />}
					onClick={() => handleClick('Search')}
				/>
			</Link>
			<Link href="/playlist-hub" legacyBehavior passHref locale={false}>
				<NavBarItem
					content={t('playlists')}
					href="/playlist-hub"
					onClick={() => handleClick('Playlists')}
				/>
			</Link>
			<Link href="/albums" legacyBehavior passHref locale={false}>
				<NavBarItem
					content={t('albums')}
					href="/albums"
					onClick={() => handleClick('Albums')}
				/>
			</Link>
			{/* Collections is not a Music App page */}
			<NavBarItem
				content={t('collections')}
				href="/collections"
				onClick={() => handleClick('Collections')}
			/>
			{showSoundEffects && (
				<Link href="/sound-effects" legacyBehavior passHref locale={false}>
					<NavBarItem
						aria-label={t('sound-effects')}
						content={
							<>
								<Text aria-hidden className={styles.sfx}>
									{t('sfx')}
								</Text>
								<Text aria-hidden className={styles.soundEffects}>
									{t('sound-effects')}
								</Text>
								<span className={styles.newBadge}>{t('new')}</span>
							</>
						}
						onClick={() => handleClick('Sound Effects')}
					/>
				</Link>
			)}
		</NavBar>
	)
}

export default DesktopNavBar
